import { HeaderComponent } from "./HeaderComponent";
import type { HeaderEvents } from "./HeaderEvents";

/**
 * Header экрана Account.
 */
export class AccountHeader extends HeaderComponent {

    constructor(
        events: HeaderEvents,
        private readonly email: string
    ) {
        super(events);
    }

    protected override build(): void {

        this.setLeft(

            this.createIconButton(

                "/img/back.png",

                "back",

                () => {

                    this.events.backClicked?.();

                }

            )

        );

        const center =
            document.createElement("div");

        center.style.display =
            "flex";

        center.style.alignItems =
            "center";

        center.style.gap =
            "8px";

        center.style.minWidth =
            "0";

        const logo =
            this.createLogo();

        const title =
            document.createElement("div");

        title.className =
            "header-title account-email-title";

        title.textContent =
            this.email;

        center.appendChild(
            logo
        );

        center.appendChild(
            title
        );

        this.setCenter(
            center
        );

        const logout =
            document.createElement("button");

        logout.className =
            "logout-button";

        logout.textContent =
            "Вийти";

        logout.addEventListener(
            "click",
            () => {

                this.events.logoutClicked?.();

            }
        );

        this.setRight(
            logout
        );

    }

}